window.jQuery = window.$ = require("jquery");
var processInclude = require("base/util");

// modify the events to be passive by default
require("coremh/components/enablePasiveEvents");

$(document).ready(function () {
    processInclude(require("coremh/components/clientSideValidation"));
    processInclude(require("base/components/toolTip"));
    processInclude(require("coremh/components/initSelect2"));
    processInclude(require("coremh/components/menu"));
    processInclude(require("coremh/components/backToTop"));
    processInclude(require("coremh/components/collapsibleItem"));
    processInclude(require("coremh/components/newsletter"));
    processInclude(require("coremh/components/header"));
    processInclude(require("coremh/components/veil"));
    processInclude(require("coremh/components/search"));
    processInclude(require("coremh/product/producttile"));
    processInclude(require("coremh/components/cookieSetup"));
    processInclude(require("corecountryselector/countrySelector/countrySelector"));
    processInclude(require("google/initRecaptcha"));
});

require("coremh/thirdParty/bootstrap");
require("base/components/spinner");
require("coremh/thirdParty/lazysizes.min");
require("coremh/thirdParty/slick");
require("coremh/thirdParty/select2.min");

window.debounce = require("lodash/debounce");
